import React from 'react';
import ReactDOM from 'react-dom';
import KRStopUpdateModal from './kr_stop_update';
import './kr_update';
import './okr_popup';
/**
 * stop kr update
 * @param data
 */
const openKRStopUpdateModal = (data: any) => {
    ReactDOM.render(
        <KRStopUpdateModal
            {...data}
        />,
        document.getElementById('stopMetricUpdate'),
    )
}

(window as any).openKRStopUpdateModal = openKRStopUpdateModal;
